import validate from "/grouper/web-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import authentication from "/grouper/web-frontend/modules/core/middleware/authentication.js";
import enterpriseExtraClientScripts from "/grouper/enterprise/web-frontend/modules/grouper_enterprise/middleware/extraClientScripts.js";
import manifest_45route_45rule from "/grouper/web-frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  authentication,
  enterpriseExtraClientScripts,
  manifest_45route_45rule
]
export const namedMiddleware = {
  settings: () => import("/grouper/web-frontend/modules/core/middleware/settings.js"),
  authenticated: () => import("/grouper/web-frontend/modules/core/middleware/authenticated.js"),
  workspacesAndApplications: () => import("/grouper/web-frontend/modules/core/middleware/workspacesAndApplications.js"),
  pendingJobs: () => import("/grouper/web-frontend/modules/core/middleware/pendingJobs.js"),
  staff: () => import("/grouper/web-frontend/modules/core/middleware/staff.js"),
  aiProvidersFeatureFlag: () => import("/grouper/web-frontend/modules/core/middleware/aiProvidersFeatureFlag.js"),
  impersonate: () => import("/grouper/web-frontend/modules/core/middleware/impersonate.js"),
  urlCheck: () => import("/grouper/web-frontend/modules/core/middleware/urlCheck.js"),
  dashboardRedirect: () => import("/grouper/web-frontend/modules/core/middleware/dashboardRedirect.js"),
  redirectCompletedOnboarding: () => import("/grouper/web-frontend/modules/core/middleware/redirectCompletedOnboarding.js"),
  tableLoading: () => import("/grouper/web-frontend/modules/database/middleware/tableLoading.js"),
  selectWorkspaceDatabaseTable: () => import("/grouper/web-frontend/modules/database/middleware/selectWorkspaceDatabaseTable.js"),
  dashboardLoading: () => import("/grouper/web-frontend/modules/dashboard/middleware/dashboardLoading.js"),
  selectWorkspaceBuilderPage: () => import("/grouper/web-frontend/modules/builder/middleware/selectWorkspaceBuilderPage.js"),
  selectWorkspaceAutomationWorkflow: () => import("/grouper/web-frontend/modules/automation/middleware/selectWorkspaceAutomationWorkflow.js")
}